<sd-6-17-1-icon
  library="{{ iconLibrary }}"
  name="warning"></sd-6-17-1-icon>
<div>
  {{ errorMessage }}
</div>
